import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useState, useCallback, useRef, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { Row, Col, Button } from "react-bootstrap";
import Heading from '../heading/Heading';
import LocationCard from "./Card";
import Separator from '../separator/Separator';
import { MdLocationOn } from "react-icons/md";
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import FilterAccordionInput from "../accordion/AccordionFilterInput";
import { Formik } from "formik";
import { connect, ReactReduxContext } from 'react-redux';
import { waitlistDuck } from "../../ducks/waitlist";
import { locationDuck } from "../../ducks/location";
import { debounce } from "lodash";
import { toCamel, locationUtil } from "../../util";
import { TripPlanner } from "./TripPlanner";
import Wrapper from "../wrapper/Wrapper";
import WaitlistButton from "../forms/WaitlistButton";
import * as UTIL from '../../util';
import Modal from '../modal/Modal'; //MediaQuery

import MediaQuery from 'react-responsive';
import WaitlistForm from '../forms/Waitlist';
import gaTracker from '../../util/ga-analytics/gaTracker';
var waitListOperations = waitlistDuck.operations;
var locationOperations = locationDuck.operations;
var filterValues = [{
  value: "dinein",
  displayName: "Dine-in"
}, {
  value: "curbside",
  displayName: "Curbside"
}, {
  value: "delivery",
  displayName: "Delivery"
}, {
  value: "busrv",
  displayName: "Bus/Rv"
}, {
  value: "new",
  displayName: "New"
}];
export var LocationFinder = function LocationFinder(props) {
  var _props$setActive = props.setActive,
      setActive = _props$setActive === void 0 ? function () {
    return "";
  } : _props$setActive,
      active = props.active,
      isCnbSite = props.isCnbSite,
      _props$getLocation = props.getLocation,
      getLocation = _props$getLocation === void 0 ? function () {} : _props$getLocation;
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-location-finder"
  }, !isCnbSite && /*#__PURE__*/React.createElement(Row, {
    className: "nav nav-tabs plr-15"
  }, /*#__PURE__*/React.createElement(Col, {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement("button", {
    className: "nav-link ".concat(active === 0 ? "active" : ""),
    onClick: function onClick() {
      return setActive(0);
    }
  }, "Store Finder")), /*#__PURE__*/React.createElement(Col, {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement("a", {
    className: "nav-link",
    href: "/Locations/States"
  }, "Browse by State"))), active === 0 ? /*#__PURE__*/React.createElement(StoreFinder, props) : /*#__PURE__*/React.createElement(TripPlanner, props));
};
export var StoreFinder = function StoreFinder(props) {
  //Debounce doesn't play nice with functional components, use callback fixed
  var getLocationsWrapper = useCallback(debounce(function (getLocationByZipcode, zipcode, filters) {
    if (zipcode) {
      getLocationByZipcode(filters);
    }
  }, 600), []);
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-location-finder__finder-wrapper"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "cb-type-display-1 cb-color-red-900 plr-15"
  }, props.isCnbSite ? "Find a Location" : "Find a Cracker Barrel"), /*#__PURE__*/React.createElement(ConnectedStoreFinderSearch, _extends({}, props, {
    getLocationsWrapper: getLocationsWrapper
  })));
};
export var StoreFinderSearch = function StoreFinderSearch(props) {
  var _props$zipcode = props.zipcode,
      zipcode = _props$zipcode === void 0 ? "" : _props$zipcode,
      _props$results = props.results,
      propResult = _props$results === void 0 ? [] : _props$results,
      _props$mapActive = props.mapActive,
      mapActive = _props$mapActive === void 0 ? "" : _props$mapActive,
      _props$changeZipCode = props.changeZipCode,
      changeZipCode = _props$changeZipCode === void 0 ? function () {
    return "";
  } : _props$changeZipCode,
      _props$getLocationByZ = props.getLocationByZipcode,
      getLocationByZipcode = _props$getLocationByZ === void 0 ? function () {
    return "";
  } : _props$getLocationByZ,
      _props$setMapActive = props.setMapActive,
      setMapActive = _props$setMapActive === void 0 ? function () {
    return "";
  } : _props$setMapActive,
      _props$getLocationsWr = props.getLocationsWrapper,
      getLocationsWrapper = _props$getLocationsWr === void 0 ? function () {
    return "";
  } : _props$getLocationsWr,
      locationFinderErr = props.locationFinderErr,
      isCnbSite = props.isCnbSite,
      store = props.store,
      _props$getLocation2 = props.getLocation,
      getLocation = _props$getLocation2 === void 0 ? getLocation : _props$getLocation2,
      _props$setLocation = props.setLocation,
      setLocation = _props$setLocation === void 0 ? setLocation : _props$setLocation,
      location = props.location,
      showForm = props.showForm,
      waitlistConfirmation = props.waitlistConfirmation,
      waitlistLoading = props.waitlistLoading,
      waitlistActive = props.waitlistActive,
      isError = props.isError,
      _props$toggleWaitlist = props.toggleWaitlist,
      toggleWaitlist = _props$toggleWaitlist === void 0 ? function () {
    return "";
  } : _props$toggleWaitlist;
  var history = useHistory();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      filters = _useState4[0],
      setFilters = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      results = _useState6[0],
      setResults = _useState6[1]; //On filter change, get Locations


  useEffect(function () {
    getLocationsWrapper(getLocationByZipcode, zipcode, filters);
  }, [filters]);
  useEffect(function () {
    if (isCnbSite) {
      if (Array.isArray(propResult)) {
        var results = propResult.map(function (el) {
          return toCamel(el);
        });
        var cnbResults = results.filter(function (mapItem) {
          return mapItem.cnbKitchen === true;
        });
        setResults(cnbResults);
      }
    } else {
      Array.isArray(propResult) ? setResults(propResult.map(function (el) {
        return toCamel(el);
      })) : "";
    }
  }, [propResult]);
  useEffect(function () {
    setMapActive();
  }, []);

  var onChange = function onChange(arg) {
    var setFieldValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
      return "";
    };
    changeZipCode(arg);
    getLocationsWrapper(getLocationByZipcode, zipcode, filters);
  };

  var setStore = function setStore(store, redirectUrl) {
    var locationIds = UTIL.locationIdsUrl();
    setLocation(store, Object.keys(locationIds).length ? locationIds.retaincart : "false");

    if (redirectUrl != "") {
      history.push(redirectUrl);
    }
  };

  var ga = function ga() {
    var data = {
      gtm: {
        uniqueEventId: '25',
        elementId: "banner-joinwaitlist"
      },
      event: 'gtm.click'
    };
    gaTracker(data);
  };

  var handleWaitlistModal = function handleWaitlistModal() {
    ga();
    toggleWaitlist(true);
  };

  var handleClose = function handleClose() {
    toggleWaitlist();
  };

  var waitListTitle = showForm ? "Join the Wait List" : "";
  return /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      storeFinder: zipcode
    }
  }, function (props) {
    var setFieldValue = props.setFieldValue,
        values = props.values;
    useEffect(function () {
      setFieldValue("storeFinder", zipcode);
    }, [zipcode]);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
      show: waitlistActive,
      hide: handleClose,
      title: waitListTitle
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(WaitlistForm, {
      store: store,
      location: location,
      results: results,
      confirmation: waitlistConfirmation,
      isLoading: waitlistLoading,
      isError: isError
    }))), /*#__PURE__*/React.createElement("div", {
      className: "plr-15"
    }, /*#__PURE__*/React.createElement("div", {
      className: "position-relative"
    }, /*#__PURE__*/React.createElement(FilterAccordionInput, _extends({}, props, {
      controlled: true,
      value: values.storeFinder,
      label: "City and State or Zipcode",
      onChange: onChange,
      name: "storeFinder"
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      className: "cb-color-red-900"
    }, results.length, " Stores Nearby"), !isCnbSite && /*#__PURE__*/React.createElement(Col, {
      className: "text-right"
    }, /*#__PURE__*/React.createElement("button", {
      className: "cb-button-unstyled",
      onClick: function onClick() {
        return setShow(!show);
      }
    }, /*#__PURE__*/React.createElement("p", {
      className: "cb-color-blue-700"
    }, "Filter ", filters.length ? "(".concat(filters.length, ")") : "", " ", show ? /*#__PURE__*/React.createElement(FaAngleUp, null) : /*#__PURE__*/React.createElement(FaAngleDown, null))))), show && /*#__PURE__*/React.createElement(Row, {
      className: "cb-location-finder__filters"
    }, filterValues.map(function (el, index) {
      return /*#__PURE__*/React.createElement(FilterBox, {
        id: "filter" + index,
        setFilters: setFilters,
        filters: filters,
        value: el.value,
        displayName: el.displayName
      });
    }))), /*#__PURE__*/React.createElement(Wrapper, {
      layout: {
        background: "solid"
      },
      className: "cb-location-finder__cards mt-16"
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, !locationFinderErr && Array.isArray(results) ? results.map(function (el, i) {
      return /*#__PURE__*/React.createElement("div", {
        className: "mt-16"
      }, /*#__PURE__*/React.createElement(FinderCard, {
        store: store,
        data: el,
        key: "finder-".concat(i),
        handlePreferred: function handlePreferred() {
          return "";
        },
        index: i,
        mapActive: mapActive,
        isCnbSite: isCnbSite,
        getLocation: getLocation,
        setLocation: setStore,
        handleShowModal: handleWaitlistModal
      }));
    }) : /*#__PURE__*/React.createElement(NoLocationsFound, null)))));
  });
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    results: state.location.results,
    zipcode: state.location.zipcode,
    isLoading: state.location.isLoadingZipcode,
    isError: state.location.isError,
    err: state.location.err,
    mapActive: state.location.mapActive,
    locationFinderErr: state.location.locationFinderErr,
    showForm: state.waitlist.showForm,
    location: state.location.location,
    waitlistConfirmation: state.waitlist.confirmation,
    waitlistLoading: state.waitlist.isLoading,
    waitlistActive: state.waitlist.waitlistActive
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setLocation: function setLocation(location, retaincart) {
      return dispatch(locationOperations.setLocation(location, retaincart));
    },
    getLocation: function getLocation(data, callback) {
      return waitListOperations.setWaitlistAvailableQSR(data, callback);
    },
    changeZipCode: function changeZipCode(text) {
      return dispatch(locationOperations.changeZipCode(text));
    },
    setMapActive: function setMapActive() {
      return dispatch(locationOperations.setMapActive(undefined));
    },
    //Always 1000 options if availalbe?
    getLocationByZipcode: function getLocationByZipcode(filters) {
      return dispatch(locationOperations.getLocationByZipcode(100, undefined, filters, true));
    },
    toggleWaitlist: function toggleWaitlist() {
      return dispatch(waitListOperations.toggleWaitlist());
    }
  };
};

export var ConnectedStoreFinderSearch = connect(mapStateToProps, mapDispatchToProps)(StoreFinderSearch);
export var FinderCard = function FinderCard(_ref, props) {
  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data,
      mapActive = _ref.mapActive,
      _ref$index = _ref.index,
      index = _ref$index === void 0 ? 0 : _ref$index,
      _ref$store = _ref.store,
      store = _ref$store === void 0 ? {} : _ref$store,
      isCnbSite = _ref.isCnbSite,
      _ref$getLocation = _ref.getLocation,
      getLocation = _ref$getLocation === void 0 ? function () {} : _ref$getLocation,
      _ref$setLocation = _ref.setLocation,
      setLocation = _ref$setLocation === void 0 ? function (location) {} : _ref$setLocation,
      _ref$handleShowModal = _ref.handleShowModal,
      handleShowModal = _ref$handleShowModal === void 0 ? function () {} : _ref$handleShowModal;

  var _useState7 = useState(),
      _useState8 = _slicedToArray(_useState7, 2),
      waitTime = _useState8[0],
      setWaitTime = _useState8[1];

  var storeServiceURLs = {
    "toGo": "/menu",
    "catering": "/catering",
    "curbside": "/menu/?vendorid=" + data.vendorId,
    "waitList": "/menu/?vendorid=" + data.vendorId + "&action=getonlist"
  };
  var cnbStoreServiceURLs = {
    "doorDash": "https://www.doordash.com/" + data.cnbDoorDashUrl,
    "uberEats": "https://www.ubereats.com/" + data.cnbUberEatsUrl,
    "grubHub": "https://www.grubhub.com/" + data.cnbGrubHubUrl
  };
  var modifiers = {
    "Dine-in": true,
    "Curbside": true,
    "Delivery": true,
    "Bus/RV Friendly": false
  };
  var finderCard = useRef(null);
  var active = parseInt(index) === mapActive;
  useEffect(function () {
    if (active && finderCard) {
      var _finderCard$current;

      finderCard === null || finderCard === void 0 ? void 0 : (_finderCard$current = finderCard.current) === null || _finderCard$current === void 0 ? void 0 : _finderCard$current.scrollIntoView({
        behavior: "smooth"
      });
    }
  }, [mapActive, index]);
  var isWaitListAvailable = locationUtil.isWaitListAvailable(data);
  useEffect(function () {
    getLocation(data.storeId, setWaitTime);
  }, [data]);

  if (isCnbSite || (data === null || data === void 0 ? void 0 : data.discoverableGhostKitchen)) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "d-flex cb-location-finder__finder-card ".concat(active ? "is-active" : ""),
      ref: finderCard
    }, /*#__PURE__*/React.createElement(MdLocationOn, {
      className: "cb-location-banner__icon cb-color-blue-500"
    }), /*#__PURE__*/React.createElement("div", {
      className: "cb-location-finder__finder-card-width"
    }, /*#__PURE__*/React.createElement(LocationCard, {
      data: data,
      handlePreferred: function handlePreferred() {
        return "";
      },
      isFinder: true,
      showHeader: true,
      discoverableGhostKitchen: data === null || data === void 0 ? void 0 : data.discoverableGhostKitchen,
      isCnbSite: isCnbSite
    }), Boolean(data.specialNotes) && !isCnbSite && /*#__PURE__*/React.createElement("p", {
      className: "cb-location-finder__special-notes"
    }, data.specialNotes), data.vendorId && /*#__PURE__*/React.createElement(Row, {
      className: "row-grid cb-location-finder__no-button-padding mt-16"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: "6",
      lg: {
        span: 4,
        order: 1
      }
    }, /*#__PURE__*/React.createElement(Button, {
      className: "cb-button-primary cb-button-thin",
      href: cnbStoreServiceURLs.doorDash,
      target: "_blank"
    }, /*#__PURE__*/React.createElement(Heading, {
      className: "cb-type-title-2",
      field: {
        value: 'DoorDash'
      },
      level: "2"
    }))), /*#__PURE__*/React.createElement(Col, {
      xs: "6",
      lg: {
        span: 4,
        order: 2
      }
    }, /*#__PURE__*/React.createElement(Button, {
      className: "cb-button-primary cb-button-thin",
      href: cnbStoreServiceURLs.uberEats,
      target: "_blank"
    }, /*#__PURE__*/React.createElement(Heading, {
      className: "cb-type-title-2",
      field: {
        value: 'UberEats'
      },
      level: "2"
    }))), /*#__PURE__*/React.createElement(MediaQuery, {
      minWidth: 991
    }, /*#__PURE__*/React.createElement(Col, {
      xs: "6",
      lg: {
        span: 4,
        order: 3
      }
    }, /*#__PURE__*/React.createElement(Button, {
      className: "cb-button-primary cb-button-thin",
      href: cnbStoreServiceURLs.grubHub,
      target: "_blank"
    }, /*#__PURE__*/React.createElement(Heading, {
      className: "cb-type-title-2",
      field: {
        value: 'GrubHub'
      },
      level: "2"
    })))), /*#__PURE__*/React.createElement(MediaQuery, {
      maxWidth: 990
    }, /*#__PURE__*/React.createElement(Col, {
      xs: "12",
      lg: {
        span: 4,
        order: 3
      },
      style: {
        marginTop: "8px"
      }
    }, /*#__PURE__*/React.createElement(Button, {
      className: "cb-button-primary cb-button-thin",
      href: cnbStoreServiceURLs.grubHub,
      target: "_blank"
    }, /*#__PURE__*/React.createElement(Heading, {
      className: "cb-type-title-2",
      field: {
        value: 'GrubHub'
      },
      level: "2"
    }))))))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      lg: "11"
    }, /*#__PURE__*/React.createElement(Separator, {
      background: "default",
      display: "solid",
      image: true,
      topPadding: "xsmall",
      bottomPadding: "xsmall"
    }))));
  } else if (!isCnbSite && !(data === null || data === void 0 ? void 0 : data.discoverableGhostKitchen)) {
    var _waitTime$Quote, _waitTime$Quote2;

    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "d-flex cb-location-finder__finder-card ".concat(active ? "is-active" : ""),
      ref: finderCard
    }, /*#__PURE__*/React.createElement(MdLocationOn, {
      className: "cb-location-banner__icon cb-color-blue-500"
    }), /*#__PURE__*/React.createElement("div", {
      className: "cb-location-finder__finder-card-width"
    }, /*#__PURE__*/React.createElement(LocationCard, {
      data: data,
      handlePreferred: function handlePreferred() {
        return "";
      },
      isFinder: true,
      showHeader: true
    }), Boolean(data.specialNotes) && /*#__PURE__*/React.createElement("p", {
      className: "cb-location-finder__special-notes"
    }, data.specialNotes), data.vendorId && !data.temporarilyclosed && /*#__PURE__*/React.createElement(Row, {
      className: "row-grid cb-location-finder__no-button-padding mt-16 justify-content-lg-end"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: "6",
      lg: {
        span: 4,
        order: 2
      }
    }, /*#__PURE__*/React.createElement(Button, {
      className: "cb-button-primary cb-button-thin",
      onClick: function onClick() {
        return setLocation(data, storeServiceURLs.catering);
      }
    }, /*#__PURE__*/React.createElement(Heading, {
      field: {
        value: 'Order Catering'
      },
      level: "3"
    }))), /*#__PURE__*/React.createElement(Col, {
      xs: "6",
      lg: {
        span: 4,
        order: 3
      }
    }, /*#__PURE__*/React.createElement(Button, {
      className: "cb-button-primary cb-button-thin",
      onClick: function onClick() {
        return setLocation(data, storeServiceURLs.toGo);
      }
    }, /*#__PURE__*/React.createElement(Heading, {
      field: {
        value: 'Order To-Go'
      },
      level: "3"
    }))), !(isWaitListAvailable && !data.temporarilyclosed && (waitTime === null || waitTime === void 0 ? void 0 : waitTime.Quote)) && /*#__PURE__*/React.createElement(Col, {
      lg: {
        order: 1
      }
    }), isWaitListAvailable && !data.temporarilyclosed && (waitTime === null || waitTime === void 0 ? void 0 : waitTime.Quote) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MediaQuery, {
      minWidth: 991
    }, /*#__PURE__*/React.createElement(Col, {
      xs: "12",
      className: "mt-lg-4",
      lg: {
        span: 8,
        order: 4
      }
    }, /*#__PURE__*/React.createElement(WaitlistButton, {
      store: store,
      storeId: data.storeId,
      className: "cb-button-secondary cb-button-thin",
      ctaClick: function ctaClick() {
        setLocation(data, "");
        handleShowModal();
      },
      style: {
        'padding': '10px 20px'
      }
    }, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
      className: "cb-type-body-1"
    }, waitTime && ((_waitTime$Quote = waitTime.Quote) === null || _waitTime$Quote === void 0 ? void 0 : _waitTime$Quote.ConsumerQuoteString.replace('About ', '').split(' ')[0]), " min wait")))), /*#__PURE__*/React.createElement(MediaQuery, {
      maxWidth: 990
    }, /*#__PURE__*/React.createElement(Col, {
      xs: "12",
      lg: {
        span: 4,
        order: 1
      },
      style: {
        marginTop: "8px"
      }
    }, /*#__PURE__*/React.createElement(Button, {
      className: "cb-button-secondary cb-button-thin",
      onClick: function onClick() {
        setStore(jssInfo, "");
        handleWaitlistModal();
      }
    }, /*#__PURE__*/React.createElement(Heading, {
      field: {
        value: 'Join Wait List'
      },
      level: "3"
    }), /*#__PURE__*/React.createElement(Heading, {
      className: "cb-type-body-1",
      field: {
        value: "".concat(waitTime && ((_waitTime$Quote2 = waitTime.Quote) === null || _waitTime$Quote2 === void 0 ? void 0 : _waitTime$Quote2.ConsumerQuoteString.replace('About ', '').split(' ')[0]), " min wait")
      },
      level: "3"
    })))))))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      lg: "11"
    }, /*#__PURE__*/React.createElement(Separator, {
      background: "default",
      display: "solid",
      image: true,
      topPadding: "xsmall",
      bottomPadding: "xsmall"
    }))));
  }
};

var FilterBox = function FilterBox(props) {
  var id = props.id,
      _props$setFilters = props.setFilters,
      setFilters = _props$setFilters === void 0 ? function () {
    return "";
  } : _props$setFilters,
      _props$value = props.value,
      value = _props$value === void 0 ? "" : _props$value,
      _props$filters = props.filters,
      filters = _props$filters === void 0 ? [] : _props$filters,
      _props$displayName = props.displayName,
      displayName = _props$displayName === void 0 ? "" : _props$displayName;

  var filterArrayRemove = function filterArrayRemove(array, el) {
    var index = array.indexOf(el);
    if (index === -1) array.push(el);else {
      array.splice(index, 1);
    }
    return array;
  };

  return /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: filters.indexOf(value) !== -1,
    onChange: function onChange() {
      return setFilters(_toConsumableArray(filterArrayRemove(filters, value)));
    },
    value: value,
    id: id
  }), /*#__PURE__*/React.createElement("label", {
    className: "brown-400 pl-8",
    for: id
  }, displayName));
};

export var NoLocationsFound = function NoLocationsFound() {
  return /*#__PURE__*/React.createElement("div", {
    className: "h-100 cb-location-finder__no-locations"
  }, /*#__PURE__*/React.createElement("h2", null, "No locations found, please retry your search"));
};